// ======================================================================
// File Name       : SessionStorageConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const USER_QUERY = 'USER_QUERY';